module.exports = __webpack_public_path__ + "static/img/car.83a437ef.webp";